/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_DescriptionInputs */

const en_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the full job description here...`)
};

const de_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige Stellenbeschreibung hier einfügen...`)
};

const fr_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colle la description complète du poste ici...`)
};

const es_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue la descripción completa del puesto aquí...`)
};

const it_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla qui la descrizione completa del lavoro...`)
};

const nl_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hier de volledige vacaturetekst...`)
};

const pl_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wklej tutaj pełny opis stanowiska...`)
};

const fi_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liitä koko työpaikkakuvaus tähän...`)
};

const da_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsæt den fulde jobbeskrivelse her...`)
};

const sv_jobs_placeholder_description = /** @type {(inputs: Jobs_Placeholder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klistra in hela jobbbeskrivningen här...`)
};

/**
* | output |
* | --- |
* | "Paste the full job description here..." |
*
* @param {Jobs_Placeholder_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_description = /** @type {((inputs?: Jobs_Placeholder_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_description(inputs)
	if (locale === "fr") return fr_jobs_placeholder_description(inputs)
	if (locale === "es") return es_jobs_placeholder_description(inputs)
	if (locale === "it") return it_jobs_placeholder_description(inputs)
	if (locale === "nl") return nl_jobs_placeholder_description(inputs)
	if (locale === "pl") return pl_jobs_placeholder_description(inputs)
	if (locale === "fi") return fi_jobs_placeholder_description(inputs)
	if (locale === "da") return da_jobs_placeholder_description(inputs)
	if (locale === "sv") return sv_jobs_placeholder_description(inputs)
	return en_jobs_placeholder_description(inputs)
});